module.exports = __webpack_public_path__ + "static/media/races_icon_banner.699cb569.svg";